import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHighlighter16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconHighlighter16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m11.578 3.293 1.133 1.135c.368.368.392.958.056 1.355L8.439 10.9 5.12 7.574l5.107-4.337a.997.997 0 0 1 1.352.056M4.59 8.458l-.728 1.943 1.757 1.761 1.94-.73zm4.99-5.985a1.995 1.995 0 0 1 2.705.112l1.133 1.135c.735.737.783 1.916.111 2.71l-4.408 5.212c-.22.26-.503.46-.821.58l-2.33.877a1 1 0 0 1-.775-.03l-.58.534a1.5 1.5 0 0 1-1.014.396h-.102c-1.347 0-2.01-1.644-1.04-2.582l.535-.518a1 1 0 0 1-.068-.85L3.8 7.714c.12-.32.32-.603.579-.824zm-5.904 9.158.768.77-.505.465a.5.5 0 0 1-.338.132h-.102a.5.5 0 0 1-.346-.86zM9 13a.5.5 0 0 0 0 1h3.5a.5.5 0 1 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHighlighter16);
